import React from 'react';
import { WARNING_SCOPE } from '../../../constants/EventWarningTypes';
import { getEventWarningWithScope } from '../../../services/calendarWarningService';
import { EVENT_REAPPRAISAL_RATIONALE_STATUS_MAP } from '../../../constants/EventReappraisalRationaleStatus';

/**
 * @typedef {object} ReappraisalRationaleStatusProps
 * @property {Array<*>} [warningTypes]
 */

/**
 * @param {ReappraisalRationaleStatusProps} props
 */
const ReappraisalRationaleStatus = props => {
  const { warningTypes = [] } = props;

  const reappraisalRationaleWarning = getEventWarningWithScope(
    warningTypes,
    WARNING_SCOPE.REAPPRAISAL_RATIONALE
  );
  if (!reappraisalRationaleWarning) {
    return null;
  }

  const reappraisalRatioanleStatus = EVENT_REAPPRAISAL_RATIONALE_STATUS_MAP.get(
    reappraisalRationaleWarning
  );

  return <div className='bold'>Reappraisal Rationale Status: {reappraisalRatioanleStatus}</div>;
};

export default ReappraisalRationaleStatus;
